import React, { useState } from 'react';
import { DashboardSettings } from '../../myTechHelpHub/partials/DashboardSettings';
import { DashboardProfile } from '../../myTechHelpHub/partials/DashboardProfile';
import { RegisterAccount } from '../../myTechHelpHub/partials/RegisterAccount';
import { ChangeAccountDetails } from '../../myTechHelpHub/partials/ChangeAccountDetails';
import { HubTabs } from '../../myTechHelpHub/components/HubTabs';
import {
  MainTabs,
  AccordionSection,
  AccordionContent,
  AccordionTitleContent,
  MediumDiv,
} from '../styled.playgroundTechHelpHub';
import { Accordion } from '../../common/sharedComponents/Accordion';
import { ButtonBlockColumn } from './../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../common/sharedComponents/buttons/ButtonLarge';
import { Calendar } from '../../common/icons/Calendar';
import { ButtonMedium } from '../../common/sharedComponents/buttons/ButtonMedium';
import { ButtonSmall } from '../../common/sharedComponents/buttons/ButtonSmall';

export function PlaygroundTechHelpHub () {
  // START - ACCORDION

  const accordions = [
    {
      title: 'Dashboard',
      content: [
        'Dashboard Settings',
        'Performance Snapshots',
        'Department Benchmarking',
        'Trending Scores',
        'Improvement Opportunities',
      ],
    },
    {
      title: 'Dashboard',
      content: [
        'Dashboard Settings',
        'Performance Snapshots',
        'Department Benchmarking',
        'Trending Scores',
        'Improvement Opportunities',
      ],
    },
  ];

  // END - ACCORDION

  // START - TABS

  const mountTabs = [
    {
      tabId: 1,
      tabName: 'Dashboard',
      subTabs: [
        {
          subTabId: 11,
          subTabName: 'Dashboard settings',
          slug: 'DashboardSettings',
          element: <DashboardSettings />,
        },
        {
          subTabId: 12,
          subTabName: 'Dashboard Profile',
          slug: 'DashboardProfile',
          element: <DashboardProfile />,
        },
      ],
    },
    {
      tabId: 2,
      tabName: 'Registration',
      subTabs: [
        {
          subTabId: 21,
          subTabName: 'Register Account',
          slug: 'RegisterAccount',
          element: <RegisterAccount />,
        },
        {
          subTabId: 22,
          subTabName: 'Change account details',
          slug: 'ChangeAccountDetails',
          element: <ChangeAccountDetails />,
        },
        {
          subTabId: 21,
          subTabName: 'Register Account',
          slug: 'RegisterAccount',
          element: <RegisterAccount />,
        },
        {
          subTabId: 22,
          subTabName: 'Change account details',
          slug: 'ChangeAccountDetails',
          element: <ChangeAccountDetails />,
        },
        {
          subTabId: 21,
          subTabName: 'Register Account',
          slug: 'RegisterAccount',
          element: <RegisterAccount />,
        },
        {
          subTabId: 22,
          subTabName: 'Change account details',
          slug: 'ChangeAccountDetails',
          element: <ChangeAccountDetails />,
        },
      ],
    },
  ];

  const jsonResponseMyTechHelpHub = {
    template: [...mountTabs],
  };

  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedSubTab, setSelectedSubTab] = useState<number>(0);
  const [showContent, setShowContent] = useState(
    mountTabs[selectedTab].subTabs[selectedSubTab].element
  );

  React.useEffect(() => {
    setShowContent(mountTabs[selectedTab].subTabs[selectedSubTab].element);
  }, [selectedTab, selectedSubTab]);

  function RenderItem (item: React.ReactNode) {
    return item;
  }
  // END - TABS

  return (
    <div>
      <div>
        <h1>Buttons</h1>
        <ButtonBlockColumn>
          <ButtonLarge title={'Big Button 1'} />
          <ButtonLarge
            leftIcon={<Calendar />}
            title={' Big Button 2'}
            outlined={true}
            inverted={true}
            rounded={true}
          />
          <MediumDiv>
            <ButtonBlockColumn>
              <ButtonMedium
                title="Medium Buttom 1"
                rounded={true}
                inverted={true}
                outlined={true}
              />
              <ButtonMedium
                title="Medium Button 2"
                leftIcon={<Calendar />}
                rounded={true}
              />
              <ButtonMedium
                title="Medium Button 2"
                backgroundColor="mintGreen"
                textColor="eerieBlack"
                rightIcon={<Calendar />}
              />
              <ButtonSmall title="Small Button 1" rounded={true} />
              <ButtonSmall
                title="Small Button 2"
                inverted={true}
                outlined={true}
                leftIcon={<Calendar />}
              />
            </ButtonBlockColumn>
          </MediumDiv>
        </ButtonBlockColumn>
      </div>
      <div>
        <h1>Accordion Component</h1>
        <AccordionSection>
          {accordions &&
            accordions.map((accordion, index) =>
              index === accordions.length - 1 ? (
                <Accordion key={index} accordion={accordion}>
                  {accordion &&
                    accordion.content.map((item, idx) => (
                      <AccordionTitleContent
                        key={idx}
                      >
                        {item}
                      </AccordionTitleContent>
                    ))}
                </Accordion>
              ) : (
                <AccordionContent>
                  <Accordion key={index} accordion={accordion}>
                    {accordion &&
                      accordion.content.map((item, idx) => (
                        <AccordionTitleContent
                          key={idx}
                        >
                          {item}
                        </AccordionTitleContent>
                      ))}
                  </Accordion>
                </AccordionContent>
              )
            )}
        </AccordionSection>
      </div>
      <div>
        <h1>Tab Component</h1>
        <MainTabs>
          <HubTabs
            template={jsonResponseMyTechHelpHub.template}
            selectedTab={selectedTab}
            selectedSubTab={selectedSubTab}
            setSelectedTab={setSelectedTab}
            setSelectedSubTab={setSelectedSubTab}
          />
        </MainTabs>
        {RenderItem(showContent)}
      </div>
    </div>
  );
}
